import { render, staticRenderFns } from "./client-agents-fee-sheets.vue?vue&type=template&id=5edb1017&scoped=true&"
import script from "./client-agents-fee-sheets.vue?vue&type=script&lang=ts&"
export * from "./client-agents-fee-sheets.vue?vue&type=script&lang=ts&"
import style0 from "./client-agents-fee-sheets.vue?vue&type=style&index=0&id=5edb1017&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edb1017",
  null
  
)

export default component.exports